import { Routes } from '@angular/router';
import { PhoneticComprehensionPage } from './phonetic-comprehension-page';
import { KlankSwitchPage } from './klank-switch-page/klank-switch-page';

export const mechanicPhoneticComprehensionRoutes: Routes = [
  {
    path: '',
    component: PhoneticComprehensionPage,
  },
  {
    path: 'klank-switch',
    component: KlankSwitchPage,
  },
];
